import React from "react";
import { useFormikContext } from "formik";
//#region types
import { CategoryBillingDetailsFieldProps } from "models/propTypes/timeReportingProjectPropTypes";
import { TimeReportingProjectFormTypes } from "models/formTypes";
//#endregion
//#region components
import BillingDetailsField from "./billingDetailsField";
//#endregion
import { FormHelper } from "utils/helpers";
import { FormFieldConstants } from "utils/constants";

const CategoryBillingDetailsField: React.FC<CategoryBillingDetailsFieldProps> = (props) => {
  const { values } = useFormikContext<any>();
  const fieldInfo = FormHelper.getTableRowFieldInfo(props.name ?? "");

  const categories = fieldInfo?.fieldName
    ? (values[fieldInfo?.fieldName] as TimeReportingProjectFormTypes.ExtendedProjectCategory[])
    : undefined;

  const category = categories?.find((_, index) => index === fieldInfo?.rowIndex);

  return (
    <BillingDetailsField
      text={category?.name}
      individualBillingModel={category?.individualBillingModel}
      hourlyRate={category?.hourlyRate}
      hours={category?.hours}
      currency={props.currency}
      currentRate={category?.currentRate}
      showCurrentRate={
        fieldInfo?.fieldName === FormFieldConstants.TimeReportingProject.ProjectMember.FutureCategoryRates
      }
    ></BillingDetailsField>
  );
};

export default CategoryBillingDetailsField;
